import type { ConfigFieldDiff } from './nltConfigFieldDiff';

export interface NltPatchSummaryStats {
  workerAgentCount: number;
  coordinatorChanged: boolean;
  metaPromptCount: number;
  totalChanges: number;
}

export function summarizePatchDiffs(diffs: ConfigFieldDiff[]): NltPatchSummaryStats {
  const workers = new Set<string>();
  let coordinatorChanged = false;
  let metaPromptCount = 0;

  diffs.forEach((diff) => {
    if (diff.path.startsWith('metaPrompts.')) {
      metaPromptCount += 1;
    } else if (diff.path.startsWith('coordinator.')) {
      coordinatorChanged = true;
    } else if (diff.path.startsWith('workers.')) {
      workers.add(diff.path.split('.')[1]);
    }
  });

  return {
    workerAgentCount: workers.size,
    coordinatorChanged,
    metaPromptCount,
    totalChanges: diffs.length,
  };
}

export function formatPatchSummaryLine(stats: NltPatchSummaryStats): string {
  const parts: string[] = [];
  const agentParts: string[] = [];
  if (stats.coordinatorChanged) agentParts.push('coordinator');
  if (stats.workerAgentCount > 0) {
    agentParts.push(
      `${stats.workerAgentCount} worker agent${stats.workerAgentCount === 1 ? '' : 's'}`
    );
  }
  if (agentParts.length > 0) {
    parts.push(`${agentParts.join(', ')} changed`);
  }
  if (stats.metaPromptCount > 0) {
    parts.push(
      `${stats.metaPromptCount} meta-prompt${stats.metaPromptCount === 1 ? '' : 's'} changed`
    );
  }
  if (parts.length === 0) {
    return `${stats.totalChanges} configuration change${stats.totalChanges === 1 ? '' : 's'}`;
  }
  return parts.join(' · ');
}

export function truncatePatchValue(value: string, maxLen = 80): string {
  const trimmed = value.replace(/\s+/g, ' ').trim();
  if (trimmed.length <= maxLen) return trimmed;
  return `${trimmed.slice(0, maxLen - 1)}…`;
}
